import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
    quizRowContainer: {
        overflowX: 'scroll',
        width: '100%',
        height: 350,
        display: 'flex',
        marginTop: 'auto',
        marginBottom: 'auto',

        '@media (max-height: 690px)': {
            height: 250,
        },
    },
    quizRow: {
        flex: 1,
        margin: 0,
        height: `100%`,
        overflow: 'auto',
        padding: 10,
    },
    colorItem: {
        width: '100%',
        height: '100%',
        // minHeight: 90,
        borderRadius: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-end',
        cursor: 'pointer',
        padding: '60px 0 12px 0',
        position: 'relative',
    },
    buttonContinue: {
        color: 'white',
        textDecoration: 'none',
        textTransform: 'none',
    },
    wrapperItem: {},
    boxItem: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRadius: 8,
        padding: 10,
        width: '175px',
        height: '100%',
    },
    itemTitle: {
        fontWeight: 'bold',
        fontFamily: 'PoppinsRegular',
        margin: 0,
        marginTop: 4,
        padding: 0,
        fontSize: 14,
    },
}));
